// staging environment shared by all apps
// each app specifies its own environment.staging.ts that is based off this file

import { RawClientConfiguration } from "./adapt-client-configuration";
import { clientConfiguration as baseClientConfiguration } from "./environment.base";

export const clientConfiguration: Partial<RawClientConfiguration> = Object.assign({}, baseClientConfiguration, {
    AdaptEnvironmentName: "Staging",
    AltoApiBaseUri: "https://staging-hq-api.theadaptway.com",
    AltoAzureTablesUrl: "https://hqstagingstorage.table.core.windows.net",
    AltoBaseUri: "https://staging-hq.theadaptway.com",
    AnalyticsProductId: "x55pm42pvs",
    ApiBaseUri: "https://staging-api.theadaptway.com",
    EmbedApiBaseUri: "https://staging-api.theadaptway.com",
    EmbedAzureTablesUrl: "https://adaptstagingstorage.table.core.windows.net",
    EmbedBaseUri: "https://staging-lumia.theadaptway.com",
    GoogleClientId: "799098505879-ibljfqb9tlghbq5ni10n2b6qlsp4mjvl.apps.googleusercontent.com",
    MicrosoftClientId: "4b24b073-832f-44ee-b189-38ab1fad4dd5",
    OneDriveClientId: "4aab023d-d1fa-4078-9190-f3a60ea2ff5b",
    ServiceApiBaseUri: "https://staging-service.theadaptway.com",
} as Partial<RawClientConfiguration>);
